<main class="main-content has-sidebar-details">
    <div>
        <div class="bg-brand-purple-50 p-8">
            <div class="flex items-center justify-between gap-6">
                <h2 class="page-title">
                    <span class="page-title-text-wrapper">
                        <span class="page-title-text">Usuários</span>
                    </span>
                </h2>
                <div class="flex items-center gap-6">
                    <button class="btn btn-primary" (click)="abrirModalCadastroUsuario()">
                        Novo Usuário
                    </button>
                </div>
            </div>
        </div>
        <div class="main-content__area">            
            <div class="py-5">
                <div class="table__wrapper" [class.loading]="carregando">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover dataTable"
                        id="tblContatos">                        
                    </table>
                    <app-carregando [showCarregando]="carregando" [isChart]="false" containerHeight="50vh" spinnerSize="40px">
                    </app-carregando>                    
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </div>
    </div>
    <app-modal-gestao-acessos [usuario]="usuarioSelecionado" [mostrarModal]="mostrarModalGestaoAcessos"
        (fecharModal)="fecharModalGestaoAcessos()"
        (permissoesSalvas)="recarregarTabela()"
        [todasPermissoes]="todasPermissoes">
    </app-modal-gestao-acessos>
    <app-modal-usuario     
    [usuario]="usuarioSelecionado"
    [mostrarModal]="mostrarModalCadastroUsuario"
    (usuarioSalvo)="recarregarTabela()"
    (fecharModal)="fecharModalCadastroUsuario()">
    </app-modal-usuario>
</main>